import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { unregister } from './registerServiceWorker'
import { IntlProvider, addLocaleData } from 'react-intl'
import { Provider} from 'react-redux'
import en from 'react-intl/locale-data/en'
import fr from 'react-intl/locale-data/fr'
import Store from "./store"

addLocaleData([...en, ...fr]);

ReactDOM.render(
	<IntlProvider locale={navigator.language} defaultLocale="fr">
		<Provider store={Store}>
			<App />
		</Provider>
	</IntlProvider>,
	document.getElementById('root')
);

unregister()



// WEBPACK FOOTER //
// ./src/index.js